import { useContext } from 'react';
import { Tooltip } from 'antd';
import { AppContext } from '@utils/AppContext';
import { MaterialManageContext } from '../../hooks/MaterialManageContext';
import Iconfont from '@utils/Iconfont';
import styles from './index.module.scss';

const HoverActions = (props) => {
    const { className, onMove, onSort, onEdit, onDelete } = props;
    const { globalOrgInfo } = useContext(AppContext);
    const { activeTab } = useContext(MaterialManageContext);
    const isPersonal = globalOrgInfo?.isPersonal;

    const stop = (e) => e.stopPropagation();

    return (
        <div className={`${styles.hoverActions} ${className || ''}`}>
            {!isPersonal && activeTab !== 'enterprise' && (
                <Tooltip title="分享到企业" mouseEnterDelay={0.5}>
                    <div className={styles.actionBtn} onClick={(e) => { stop(e); onMove?.(); }}>
                        <Iconfont type="icon-Material-MoveToEnterpriseOutlined" />
                    </div>
                </Tooltip>
            )}
            <Tooltip title="移动" mouseEnterDelay={0.5}>
                <div className={styles.actionBtn} onClick={(e) => { stop(e); onSort?.(); }}>
                    <Iconfont type="icon-Material-FolderMoveOutlined" />
                </div>
            </Tooltip>
            <Tooltip title="重命名" mouseEnterDelay={0.5}>
                <div className={styles.actionBtn} onClick={(e) => { stop(e); onEdit?.(); }}>
                    <Iconfont type="icon-Material-EditOutlined" />
                </div>
            </Tooltip>
            <Tooltip title="删除" mouseEnterDelay={0.5}>
                <div className={`${styles.actionBtn} ${styles.deleteBtn}`} onClick={(e) => { stop(e); onDelete?.(); }}>
                    <Iconfont type="icon-Material-DeleteOutlined" />
                </div>
            </Tooltip>
        </div>
    );
};

export default HoverActions;
